export default __webpack_public_path__ + "static/media/toggleLiveDataInActiveIcon.65537d26.svg";